/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from '@apollo/client';
import { useMemo } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CancelUplifts, CancelUpliftsVariables } from '@/graphql/contracts/_generated_/cancelUplifts.mutation';
import { CancelUpliftsInputType, ResultEnum } from '@/graphql/contracts/_generated_/contracts';
import { notificationService } from '@/services/notification/notification.client';

import CancelUpliftsMutation from '@/graphql/contracts/cancelUplifts.mutation.gql';

export interface CancelUpliftsParams {
  upliftIdsAndReason: CancelUpliftsInputType;
  onSuccess?: () => void;
}

export function useCancelUplifts() {
  const [mutate] = useMutation<CancelUplifts, CancelUpliftsVariables>(
    CancelUpliftsMutation,
    {
      client: apolloClientContracts,
      onError: (err) =>
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger',
        }),
    },
  );

  const cancelUplifts = ({ upliftIdsAndReason, onSuccess }: CancelUpliftsParams) => {
    mutate({
      variables: {
        input: upliftIdsAndReason,
      },
      onCompleted: (response) => {
        if (response.bulkCancelUplifts.status === ResultEnum.ERROR) {
          return notificationService.open({
            title: 'Error',
            text: response.bulkCancelUplifts.errors[0].error ?? 'Unknown error',
            type: 'danger',
          });
        }

        if (response?.bulkCancelUplifts.status === ResultEnum.SUCCESS) {
          onSuccess?.();
        }

        notificationService.open({
          title: 'Cancel Uplifts',
          text: 'Uplifts cancelled successfully',
          type: 'success',
        });
      },
    });
  };

  return useMemo(
    () => ({
      cancelUplifts,
    }),
    [],
  );
}
